











import {
  computed,
  defineComponent, ref, useFetch, useMeta, useRoute,
} from '@nuxtjs/composition-api';

import ProductsListing from '~/components/ProductsListing/ProductsListing.vue';
import { PRINTERS_CATEGORY_ID, PRINTERS_CATEGORY_UID } from '~/constants';
import { getMetaInfo } from '~/helpers/getMetaInfo';
import { getDynamicCategory } from '~/helpers/middleware/pagePreloadHelpers';
import useCategory from '~/modules/catalog/category/composables/useCategory';
import { CategoryTree } from '~/modules/GraphQL/types';
import { usePageStore } from '~/stores/page';

export default defineComponent({
  name: 'PrintersPage',
  components: {
    ProductsListing,
  },
  middleware: [
    'url-resolver',
    'page-preload-resolver',
  ],
  setup() {
    const { routeData, category: categoryFromStore } = usePageStore();
    const categoryRef = ref<CategoryTree>(categoryFromStore);
    const { loadCategoryMeta, loading } = useCategory();
    const isActive = computed(() => categoryRef.value?.title);
    const route = useRoute();
    const dynamicCategory = computed(() => getDynamicCategory(route.value.path));

    useFetch(async () => {
      if (!categoryRef.value) {
        categoryRef.value = await loadCategoryMeta({ category_uid: routeData.uid });
      }
    });

    useMeta({
      bodyAttrs: {
        class: 'overflow-x-visible md_overflow-x-hidden',
      },
      ...getMetaInfo(dynamicCategory.value ? {} : categoryRef.value, false, routeData.canonicalUrl, false),
    });

    return {
      categoryRef,
      loading,
      isActive,
      categoryUid: routeData.uid,
      PRINTERS_CATEGORY_ID,
      PRINTERS_CATEGORY_UID,
    };
  },
  head() {
    return {};
  },
});
